export const InputIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
    <path d="M2.5 2H13.5" stroke="#151515" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M8 15V2" stroke="#151515" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);
